// get all logos in the element
const getLogosItem = (slideParent) => {
  return slideParent.querySelectorAll('ul li');
};

// generate animation speed
const generateAnimationSpeed = (elem) => {
  const elementDataSpeed = elem.children[0].getAttribute('animation-duration');
  return elementDataSpeed;
};

// logo count for enable slider
const enableSlider = (elem) => {
  const logoCount = elem.children[0].getAttribute('logo-count-enable-slider');
  return logoCount;
};

const commonLogoSliders = document.querySelectorAll('.e-lgs');

if (commonLogoSliders.length > 0) {
  const logoPlayHandler = (slidersData) => {
    const sliderParent = slidersData.firstSlider.parent,
      sliderLogos = slidersData.firstSlider.logos;

    const desktopLogoCount = sliderLogos.length,
      animateSpeed = generateAnimationSpeed(sliderParent);
    // set slider animate class if logo count more than 4
    const sliderStartClass =
      desktopLogoCount > enableSlider(sliderParent)
        ? 'start-marquee'
        : 'stop-playing';

    sliderParent.querySelector('ul').classList.add(sliderStartClass);
    sliderParent.querySelector('ul').innerHTML = '';

    for (let i = 0; i < 6; i++) {
      const sliderList = sliderParent.querySelector('ul');
      const cloneLogosHTML = Array.from(sliderLogos)
        .map((logo) => logo.outerHTML)
        .join('');
      sliderList.insertAdjacentHTML('beforeend', cloneLogosHTML);
    }

    sliderParent.querySelector(
      'ul',
    ).style.animationDuration = `${animateSpeed}s`;
  };

  if (commonLogoSliders.length !== 0) {
    // looping all logo slider sections
    commonLogoSliders.forEach((ele) => {
      const logoSliderSingleSection = ele;
      if (logoSliderSingleSection) {
        const logoSliders =
          logoSliderSingleSection.querySelectorAll('.e-lgs__wrap');
        // collect slide logos
        const firstSlider = logoSliders[0];
        const firstSlideLogos = getLogosItem(firstSlider);
        // create sliders object for modification
        const slidersData = {
          firstSlider: {
            parent: firstSlider,
            logos: firstSlideLogos,
          },
        };
        logoPlayHandler(slidersData);
      }
    });
  }
}
window.addEventListener('load', function () {
  commonLogoSliders.forEach((element) => {
    element.classList.add('loaded');
  });
});
